import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

const PAGE_SIZE = 10;

export function mapQuote(snap) {
  return { id: snap.id, ...snap.data() };
}

export function quoteTotal(q) {
  const items = Array.isArray(q?.items) ? q.items : [];
  return items.reduce((sum, it) => {
    const line = it.subtotalAfterDiscounts ?? Number(it.price || 0) * Number(it.quantity || 0);
    return sum + Number(line || 0);
  }, 0);
}

/** Colección real `cotizaciones` — mismo criterio que CotizacionesScreen. */
export async function listQuotes({ ruc, pageSize = PAGE_SIZE, cursor = null, search = '', includeCancelled = false }) {
  if (!ruc) throw new Error('RUC requerido');
  const constraints = [where('ruc', '==', ruc)];
  if (!includeCancelled) constraints.push(where('cancelado', '==', false));

  if (search) {
    const term = search.trim().toLowerCase();
    const q = query(collection(db, 'cotizaciones'), ...constraints, orderBy('cotizacion', 'desc'), limit(pageSize * 3));
    const snap = await getDocs(q);
    const items = snap.docs
      .map(mapQuote)
      .filter((c) => {
        const num = String(c.cotizacion ?? '');
        const cliente = String(c.cliente || '').toLowerCase();
        return num.includes(term) || cliente.includes(term);
      })
      .slice(0, pageSize);
    return { items, cursor: null, hasMore: false };
  }

  const q = cursor
    ? query(collection(db, 'cotizaciones'), ...constraints, orderBy('cotizacion', 'desc'), startAfter(cursor), limit(pageSize))
    : query(collection(db, 'cotizaciones'), ...constraints, orderBy('cotizacion', 'desc'), limit(pageSize));

  const snap = await getDocs(q);
  const last = snap.docs[snap.docs.length - 1] || null;
  return {
    items: snap.docs.map(mapQuote),
    cursor: last,
    hasMore: snap.docs.length === pageSize,
  };
}

export async function getQuote(id) {
  const snap = await getDoc(doc(db, 'cotizaciones', id));
  if (!snap.exists()) throw new Error('Cotización no encontrada');
  return mapQuote(snap);
}

/**
 * Cancelar cotización (flag cancelado=true, igual que el core).
 * NO descarga stock aquí: la conversión a pedido se hace en la app móvil
 * (convertirCotizacionEnPedido con FEFO).
 */
export async function cancelQuote(id) {
  await updateDoc(doc(db, 'cotizaciones', id), { cancelado: true });
}
